const searchBar = {
  'Lugar de trabajo': 'Lugar de trabajo',
  'Buscar trabajo': 'Buscar trabajo',
}

export default searchBar
